'use strict';

var getUnionIntervals = require('./getUnionIntervals.cjs');

const getUnionIntervalsMultiple = (intervals) => {
  return [...intervals].sort((a, b) => a.start - b.start).reduce((acc, interval) => {
    const last = acc[acc.length - 1];
    if (!last) {
      acc.push(interval);
      return acc;
    }
    const unionResult = getUnionIntervals(last, interval);
    return acc.slice(0, -1).concat(unionResult);
  }, []);
};

module.exports = getUnionIntervalsMultiple;
//# sourceMappingURL=getUnionIntervalsMultiple.cjs.map
